import { Component, Input }   from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NgForm }             from '@angular/forms';
import { TranslateService }   from '@ngx-translate/core';
import { UIRouter }           from '@uirouter/core';

import { AmsRewardsService }        from './ams-rewards.service';
import { CodeTypeModel }            from '../core/models/code-type';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { CompanyService }           from '../companies/company.service';
import { MessagesService }          from '../messages/messages.service';

@Component({
  selector   : 'ams-rewards-settings',
  template: require('./ams-rewards.settings.component.html')
})
export class AmsRewardsSettingsComponent {
  @BlockUI('amsRewardsSettingsBlock') block : NgBlockUI;

  @Input() amsAutoClubs      : Array<CodeTypeModel>;
  @Input() amsFileFrequencies: Array<CodeTypeModel>;
  @Input() session           : any;
  @Input() settings          : CompanyIntegrationsModel;

  title: string = this.amsRewardsService.title;

  constructor (
    private amsRewardsService: AmsRewardsService,
    private companyService   : CompanyService,
    private messagesService  : MessagesService,
    private router           : UIRouter,
    private translateService : TranslateService,
  ) {}

  activate () : void {
    this.amsRewardsService.activate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  canSave ( form : NgForm ) : boolean {
    const controls = form.form.controls;

    return Object.entries(controls)
      .every(([ key, control ] : [ string, any ]) => {
        const isPassword = key === 'ams_password' || key === 'confirm_ams_password';

        return isPassword
          ? !control || control.pristine || control.valid
          : !!control?.valid;
    });
  }

  deactivate () : void {
    this.amsRewardsService.deactivate()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.REMOVED', {
        name: this.title
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error));
  }

  downloadCsv () : void {
    this.amsRewardsService.downloadCsv()
    .catch(error => this.messagesService.error(error));
  }

  isActive () : boolean {
    return this.companyService.hasIntegration('ams-rewards');
  }

  save ( form : NgForm ) : void {
    this.block.start();

    this.amsRewardsService.save(this.settings)
    .then(( message : string ) => {
      this.messagesService.show(message, 'success');

      this.router.stateService.reload();
    })
    .catch(error => this.messagesService.error(error))
    .finally(() => this.block.stop());;
  }
}
